import { selectAll, addClass, removeClass } from "../utils/utils";

export class ShowMore {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.showMore = selectAll("[data-show-more]");
    this.showLess = selectAll("[data-show-less]");
  }

  render() {
    this.openText();
    this.closeText();
  }

  openText = () => {
    for(let showButton of this.showMore) {
      showButton.addEventListener('click', () => {
        showButton.closest('[data-review-description]').querySelector('[data-truncated]').classList.add('hide');
        showButton.closest('[data-review-description]').querySelector('[data-truncated-full]').classList.remove('hide');
        showButton.closest('.review_info__spacing').classList.add('expanded');
      })
    }
  }

  closeText = () => {
    for(let showLess of this.showLess) {
      showLess.addEventListener('click', () => {
        showLess.closest('[data-review-description]').querySelector('[data-truncated]').classList.remove('hide');
        showLess.closest('[data-review-description]').querySelector('[data-truncated-full]').classList.add('hide');
        showLess.closest('.review_info__spacing').classList.remove('expanded');
      })
    }
  }
}
